'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentLineageData(essential, orgName) {
  this.Lx = null;
  this.XI = null;
  this.Lx = essential;
  this.XI = orgName;
}
export { $c_Lapp_data_AppDocumentLineageData as $c_Lapp_data_AppDocumentLineageData };
$p = $c_Lapp_data_AppDocumentLineageData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentLineageData;
/** @constructor */
function $h_Lapp_data_AppDocumentLineageData() {
}
export { $h_Lapp_data_AppDocumentLineageData as $h_Lapp_data_AppDocumentLineageData };
$h_Lapp_data_AppDocumentLineageData.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentLineageData)) {
    var x = this.Lx;
    var x$2 = x$0.Lx;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      return (this.XI === x$0.XI);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "AppDocumentLineageData";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Lx;
  }
  if ((n === 1)) {
    return this.XI;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "essential";
  }
  if ((n === 1)) {
    return "orgName";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_AppDocumentLineageData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j4)));
}
export { $isArrayOf_Lapp_data_AppDocumentLineageData as $isArrayOf_Lapp_data_AppDocumentLineageData };
var $d_Lapp_data_AppDocumentLineageData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentLineageData, "app.data.AppDocumentLineageData", ({
  j4: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentLineageData as $d_Lapp_data_AppDocumentLineageData };
//# sourceMappingURL=app.data.-App-Document-Lineage-Data.js.map
